<template>
  <div>
    <div v-if="image.url" class="mb-4">
      <img :src="image.url" alt class="w-64" v-if="preview" />
      <label :for="label + '_delete'" class="inline-flex items-center mt-2">
        <input
          type="checkbox"
          :id="label + '_' + id + '_delete'"
          v-model="image.delete"
          class="form-checkbox"
        />
        <span class="ml-2">Delete</span>
      </label>
    </div>
    <image-input
      :value="image.new_url"
      @upload="image.new_url = $event"
      :label="label"
      :preview="preview"
      :id="id"
    />
  </div>
</template>

<script>
export default {
  props: {
    id: {},
    value: {},
    label: {},
    preview: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      image: this.value
    }
  },
  watch: {
    value() {
      this.image = this.value
    },
    image() {
      this.$emit('input', this.image)
    }
  }
}
</script>

<style lang="scss" scoped></style>
